import Upload from './upload'
import Page from './page'
// import tinymce from './tinymce'
import dialog from './dialog'
import Popload from './popload'
import OssUpload from './ossupload'

const Components = {
    install:function(Vue)
    {
        Vue.component('Ipo3Upload',Upload);
        Vue.component('Ipo3Page',Page);
        // Vue.component('Ipo3Edit',tinymce);
        Vue.component('Ipo3Dialog',dialog);
        Vue.component('Ipo3Popload',Popload);
        Vue.component('Ipo3Ossupload',OssUpload);
    }
}

// const  Components = [
//     ipo3_upload,
// ];

export default Components;